export const StringOnlyNumbers = (value: string) => {
    if (value) {
        return value.replace(/\D/g, '');
    }
    return value;
};

export const StringOnlyAlphaNumeric = (value: string) => {
    if (value) {
        return value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    }
    return value;
};

export const IsCnpjAlphaNumeric = (value: string) => {
    const normalizedValue = StringOnlyAlphaNumeric(value || '');
    return /[A-Z]/.test(normalizedValue) || normalizedValue.length > 11;
};

export class CNPJ {
    private static readonly tamanhoCNPJSemDV: number = 12;
    private static readonly regexCNPJSemDV: RegExp = /^([A-Z\d]){12}$/;
    private static readonly regexCNPJ: RegExp = /^([A-Z\d]){12}(\d){2}$/;
    private static readonly regexCaracteresMascara: RegExp = /[./-]/g;
    private static readonly regexCaracteresNaoPermitidos: RegExp = /[^A-Z\d./-]/i;
    private static readonly valorBase: number = "0".charCodeAt(0);
    private static readonly pesosDV: number[] = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    private static readonly cnpjZerado: string = "00000000000000";

    static isValid(cnpj: string): boolean {
        if (!this.regexCaracteresNaoPermitidos.test(cnpj)) {
            let cnpjSemMascara = this.removeMascaraCNPJ(cnpj);
            if (this.regexCNPJ.test(cnpjSemMascara) && cnpjSemMascara !== CNPJ.cnpjZerado) {
                const dvInformado = cnpjSemMascara.substring(this.tamanhoCNPJSemDV);
                const dvCalculado = this.calculaDV(cnpjSemMascara.substring(0, this.tamanhoCNPJSemDV));
                return dvInformado === dvCalculado;
            }
        }
        return false;
    }

    static calculaDV(cnpj: string): string {
        if (!this.regexCaracteresNaoPermitidos.test(cnpj)) {
            let cnpjSemMascara = this.removeMascaraCNPJ(cnpj);
            if (this.regexCNPJSemDV.test(cnpjSemMascara) && cnpjSemMascara !== this.cnpjZerado.substring(0, this.tamanhoCNPJSemDV)) {
                let somatorioDV1 = 0;
                let somatorioDV2 = 0;
                for (let i = 0; i < this.tamanhoCNPJSemDV; i++) {
                    const asciiDigito = cnpjSemMascara.charCodeAt(i) - this.valorBase;
                    somatorioDV1 += asciiDigito * this.pesosDV[i + 1];
                    somatorioDV2 += asciiDigito * this.pesosDV[i];
                }
                const dv1 = somatorioDV1 % 11 < 2 ? 0 : 11 - (somatorioDV1 % 11);
                somatorioDV2 += dv1 * this.pesosDV[this.tamanhoCNPJSemDV];
                const dv2 = somatorioDV2 % 11 < 2 ? 0 : 11 - (somatorioDV2 % 11);
                return `${dv1}${dv2}`;
            }
        }
        throw new Error("Não é possível calcular o DV pois o CNPJ fornecido é inválido");
    }

    private static removeMascaraCNPJ(cnpj: string): string {
            return cnpj.replace(this.regexCaracteresMascara, "");
    }
}

export const IsValidCnpjAlphaNumeric = (value: string) => {
        return CNPJ.isValid(StringOnlyAlphaNumeric(value || ''));
};

export const NormalizeCpfOrCnpj = (value: string) => {
    if (!value) {
        return value;
    }

    return IsCnpjAlphaNumeric(value) ? StringOnlyAlphaNumeric(value) : StringOnlyNumbers(value);
};

export const formatCpfOrCnpj = (value: string) => {
    if (!value) return value;
    const clean = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    const isCnpj = /[A-Z]/.test(clean) || clean.length > 11;

    if (isCnpj) {
        const c = clean.slice(0, 14);
        return c.replace(/^(\w{2})(\w{3})(\w{3})(\w{4})(\w{1,2})$/, '$1.$2.$3/$4-$5')
                .replace(/^(\w{2})(\w{3})(\w{3})(\w{1,4})$/, '$1.$2.$3/$4')
                .replace(/^(\w{2})(\w{3})(\w{1,3})$/, '$1.$2.$3')
                .replace(/^(\w{2})(\w{1,3})$/, '$1.$2');
    }
    const c = clean.slice(0, 11);
    return c.replace(/^(\d{3})(\d{3})(\d{3})(\d{1,2})$/, '$1.$2.$3-$4')
            .replace(/^(\d{3})(\d{3})(\d{1,3})$/, '$1.$2.$3')
            .replace(/^(\d{3})(\d{1,3})$/, '$1.$2');
};

export const StringIsNumber = (value: string) => {
    return value.length === 0 ? false : value.match(/[^\d]/g) ? false : true;
}

export function maskChassi(chassi: string) {
    if (chassi.length <= 6) return chassi; // Caso o chassi seja muito curto, evite mascarar.
    return chassi.slice(0, 3) + '****' + chassi.slice(-4); // Mantém os 3 primeiros e os 3 últimos caracteres visíveis.
}